import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom';
import Can from '../../common/guards/can';

import '../../sidenav/sidenav.css'
import './main-layout.css';
import AdminNavigation from "../admin-navigation";

class AdminLayout extends Component {
  render() {
    const {component: Component, permissions, subjectClass, action, loaded, isAdmin, dispatch, ...rest} = this.props;

    if (!isAdmin) {
      dispatch({type: 'SAVE_REQUESTED_PATH', payLoad: window.location.pathname});
    }

    return (
      <Route {...rest} render={matchProps => loaded ? (!isAdmin) ? <Redirect to='/admin/login'/> : (
        <Can action={action} subjectClass={subjectClass} cannot={<Redirect to="/admin/my-profile"/>}>
          <div>
            <div className="content-wrapper is-admin">
              <AdminNavigation />

              <Component {...matchProps} permissions={permissions}/>
            </div>
          </div>
        </Can>
      ) : (<div>Loading...</div>)}/>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    viewConfig:  state.viewConfig,
    currentUser: state.currentUser.user,
    userLoading: state.currentUser.fetching
  };
};

export default connect(mapStateToProps)(AdminLayout);



// WEBPACK FOOTER //
// ./src/components/layout/admin-layout/index.jsx